import { Component, OnInit, Input } from '@angular/core';
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-supplier-locations',
  templateUrl: './supplier-locations.component.html',
  styleUrls: ['./supplier-locations.component.scss']
})
export class SupplierLocationsComponent implements OnInit {
  p: any;
  public filterSearch;
  public loading: boolean = false;

  @Input()
  selected: any;

  @Input()
  isMobile: any;

  @Input()
  supplier: any;

  constructor(private supplierService: SupplierService) { }

  ngOnInit() {}

  unlinkLocation(locationMasterId) {
    this.loading = true;
    this.supplierService
      .unlinkLocation(locationMasterId, this.supplier.id)
      .then(() => {
        _.remove(this.supplier.locations, { locationMasterId: locationMasterId });
        this.loading = false;
      })
      .catch(e => {
        this.loading = false;
      });
  }

}
